import React, { useEffect, useState } from "react";
import { post, put, get } from "../../helpers/api_helper";
//redux
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Form, Input, Label, Row } from "reactstrap";
import Loader from "common/loader";
import { Trans } from "react-i18next";
import Breadcrumb from "components/Common/Breadcrumb";
import { UPDATE_SCREEN, ADD_SCREEN, LANGUAGES_SEARCH, SHOW_SCREEN, MODULES_SEARCH } from "helpers/api_endpoints";
import Select from "react-select";
import { set } from "lodash";

const AddScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [status, setStatus] = useState(0);
    const [moduleId, setModuleId] = useState(null);
    const [name, setName] = useState('');
    const [titled, setTitled] = useState([]);
    const [title, setTitle] = useState('');
    const [path, setPath] = useState('');
    const [languages, setLanguages] = useState([]);
    const [currentVersion, setCurrentVersion] = useState('');
    const [modules, setModules] = useState([]);

    useEffect(() => {
        setId(location.state ? location.state.id : '');
        post(`${LANGUAGES_SEARCH}`)
            .then(response => {
                setLanguages(response.data);
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })
        post(`${MODULES_SEARCH}`)
            .then(response => {
                setModules(response.data.map(el => {return {value: el.id,label: el.name}}));
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })

        const state = location.state;
        if(state && state != undefined)
        {
            get(`${SHOW_SCREEN}/${location.state.id}`)
                .then(response => {
                    const screen = response.data;
                    setName(screen.name);
                    setTitle(JSON.stringify(screen.titled));
                    setTitled(screen.titled);
                    setCurrentVersion(screen.currentVersion);
                    setStatus(screen.status);
                    setPath(screen.path);
                    setModuleId(screen.moduleId);
                })
                .catch(error => {
                    console.log(error)
                })

        }
        setLoading(false);
    }, []);

    const handleSubmit = () => {
        if(id == '')
        {
            post(ADD_SCREEN, { name, title, status, currentVersion, path, moduleId })
                .then(response => {
                    if (response.code == 201) {
                        navigate('/screens', { state: { successMsg: 'Added SuccessFully' } });
                    }
                })

        }
        else
        {
            put(UPDATE_SCREEN, { id, name, title, status, currentVersion, path, moduleId })
                .then(response => {
                    if (response.code == 200) {
                        navigate('/screens', { state: { successMsg: 'Updated SuccessFully' } });
                    }
                })

        }
    }

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }
    
    const handleName = (languageId,value) => {
        if(titled.title == undefined)
        {
            setTitled({"title": []});
        }
        const ln = titled.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            titled.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setTitle(JSON.stringify(titled));             
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumb title="Sreens" breadcrumbItem="Add / Edit Screen" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Name</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={name}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => setName(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                {
                                                    languages.map((language, index) => (
                                                        <Row key={index}>
                                                        <div className="form-group col-md-4 mt-2">
                                                            <Label className="form-label"><Trans>Title ({language.name})</Trans></Label>
                                                            <Input
                                                                name="name"
                                                                value={titled.title?.find(el => {return el[language.id]})?titled.title?.find(el => {return el[language.id]})[language.id]:''}
                                                                className="form-control"
                                                                placeholder="Enter  Name"
                                                                type="text"
                                                                onChange={(e) => handleName(language.id,e.target.value)}
                                                                required={language.id==1||language.id==2?true:false} 
                                                                ></Input>
                                                        </div>
                                                    </Row>
                                                    ))
                                                }

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Choose Module</Trans></Label>
                                                        <Select
                                                                name="moduleId"
                                                                value={modules.find(el => el.value==moduleId)}
                                                                options={modules} 
                                                                className="form-control select2"
                                                                onChange={(e) => setModuleId(e.value)}
                                                            />
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Current Version</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={currentVersion}
                                                        className="form-control"
                                                        placeholder="Enter Current Version"
                                                        type="text"
                                                        onChange={(e) => setCurrentVersion(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Path</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={path}
                                                        className="form-control"
                                                        placeholder="Enter Path"
                                                        type="text"
                                                        onChange={(e) => setPath(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="defaultCheck2"
                                                            checked={status == 1}
                                                            onClick={handleToggleCheckBoxStatus}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="defaultCheck2"
                                                        >
                                                            <Trans>Active</Trans>
                                                        </label>
                                                    </div>
                                                </div>


                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddScreen;